/*=========================================================
  BLUE ROOM STUDIO
  Viewer Controller
=========================================================*/

class BRViewer {

    constructor() {

        this.viewer = document.getElementById("br-3d-viewer");

        if (!this.viewer) return;

        /*
        ==========================================
        ELEMENTOS
        ==========================================
        */

        this.overlay =
            this.viewer.querySelector(".br-3d-viewer__overlay");

        this.closeButton =
            this.viewer.querySelector(".brstudio__close");

        this.triggers =
            document.querySelectorAll(".br-card--3d");

        /*
        ==========================================
        DEMO DATA (Sprint 2.0)
        ==========================================
        */

        this.products = [
    {
        id: 1,
        name: "Sala Oslo",
        category: "Modular",
        image: "https://cdn.shopify.com/s/files/1/0587/3984/7062/files/placeholder.png?v=1",
        glb: "https://cdn.shopify.com/3d/models/2022cc6dc90d95c2/Couch_Wide_by_Danni_Bittman_-_7Q_Ab2HLll1.glb"
    },
    {
        id: 2,
        name: "Sala Lyon",
        category: "Reclinable",
        image: "https://cdn.shopify.com/s/files/1/0587/3984/7062/files/placeholder.png?v=1",
        glb: "https://cdn.shopify.com/3d/models/2022cc6dc90d95c2/Couch_Wide_by_Danni_Bittman_-_7Q_Ab2HLll1.glb"
    },
    {
        id: 3,
        name: "Sala Dallas",
        category: "Esquinera",
        image: "https://cdn.shopify.com/s/files/1/0587/3984/7062/files/placeholder.png?v=1",
        glb: "https://cdn.shopify.com/3d/models/2022cc6dc90d95c2/Couch_Wide_by_Danni_Bittman_-_7Q_Ab2HLll1.glb"
    },
    {
        id: 4,
        name: "Sala Verona",
        category: "Premium",
        image: "https://cdn.shopify.com/s/files/1/0587/3984/7062/files/placeholder.png?v=1",
        glb: "https://cdn.shopify.com/3d/models/2022cc6dc90d95c2/Couch_Wide_by_Danni_Bittman_-_7Q_Ab2HLll1.glb"
    }
];
        /*
        ==========================================
        INICIALIZAR
        ==========================================
        */

        this.bindEvents();
        this.productsTrack =
    this.viewer.querySelector(".brstudio__products-track");

this.renderProducts();

    }

    /*=========================================================
      EVENTOS
    =========================================================*/

    bindEvents() {

        this.triggers.forEach(trigger => {

            trigger.addEventListener(

                "click",

                () => this.open()

            );

        });

        if (this.overlay) {

            this.overlay.addEventListener(

                "click",

                () => this.close()

            );

        }

        if (this.closeButton) {

            this.closeButton.addEventListener(

                "click",

                () => this.close()

            );

        }

        document.addEventListener(

            "keydown",

            (event) => {

                if (event.key === "Escape") {

                    this.close();

                }

            }

        );

    }

    /*=========================================================
      ABRIR
    =========================================================*/

    open() {

        this.viewer.classList.add("is-open");

        document.body.style.overflow = "hidden";

    }

    /*=========================================================
      CERRAR
    =========================================================*/

    close() {

        this.viewer.classList.remove("is-open");

        document.body.style.removeProperty("overflow");

    }

    /*=========================================================
      RENDER PRODUCTOS
      (Sprint 2.1)
    =========================================================*/
renderProducts() {

    if (!this.productsTrack) return;

    this.productsTrack.innerHTML = "";

    this.products.forEach((product, index) => {

        const card = document.createElement("div");

        card.className = "brstudio__product";

        if (index === 0) {

            card.classList.add("active");

        }

        card.dataset.id = product.id;

        card.innerHTML = `
            <img src="${product.image}" alt="${product.name}">

            <div>

                <h4>${product.name}</h4>

                <span>${product.category}</span>

            </div>
        `;

        this.productsTrack.appendChild(card);

    });

}

    /*=========================================================
      CARGAR PRODUCTO
      (Sprint 2.2)
    =========================================================*/

    loadProduct(product) {

        // Próximo sprint

    }

    /*=========================================================
      DESTRUIR
    =========================================================*/

    destroy() {

        // Futuro

    }

}

/*=========================================================
  INIT
=========================================================*/

document.addEventListener(

    "DOMContentLoaded",

    () => {

        window.BRViewer = new BRViewer();

    }

);